import useSingleZone from "@/features/zones/hooks/useSingleZone";
import { Events } from "@/models/database/event/Events.model";
import { clientAtom } from "@/utils/atoms/atomClient";
import {
  Card,
  Box,
  Flex,
  AspectRatio,
  Text,
  Skeleton,
  Grid,
} from "@radix-ui/themes";
import { siteRoutes } from "@/routes/siteRoutesList";
import { useAtomValue } from "jotai";
import { FC } from "react";
import DateObject from "react-date-object";
import { useNavigate } from "react-router-dom";

export const SingleEventCard: FC<Events> = ({ ...props }): JSX.Element => {
  const navigate = useNavigate();
  const { zoneItem, loading } = useSingleZone(props.zone);
  const client = useAtomValue(clientAtom);

  const url = props.zone
    ? `${siteRoutes["zone"]}${props.zone}${siteRoutes["eventAndSlug"]}${props.slug}`
    : `${siteRoutes["events"]}${props.slug}`;

  const startDate = new DateObject(props.startDate.toDate());
  const endDate = new DateObject(props.endDate.toDate());

  return (
    <>
      <Card
        size="2"
        style={{ backgroundColor: "var(--color-background)" }}
        className="card"
        onClick={() => navigate(url)}
      >
        <Box width="100%" minWidth="100%">
          <Grid
            align="center"
            justify="between"
            gap={{ initial: "2", lg: "5" }}
            columns={{ initial: "2", lg: "3" }}
          >
            <Flex align="center" gap="3" gridColumn="1 / -1">
              <Box width="48px">
                <AspectRatio ratio={1 / 1}>
                  <img
                    src={props.imageURL}
                    alt={props.title}
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </AspectRatio>
              </Box>
              <Skeleton loading={loading}>
                <Box>
                  {!client && zoneItem
                    ? `${zoneItem.title} @ ${props.title}`
                    : props.title}
                </Box>
              </Skeleton>
            </Flex>
            <Flex justify="end" gridColumn="1 / 2">
              <Text size="2" color="gray">
                {startDate.format("DD.MM.YYYY")} -{" "}
                {endDate.format("DD.MM.YYYY")}
              </Text>
            </Flex>
            <Flex justify="end" gridColumn="2 / 3">
              <Text size="2" color="gray">
                {props.location}
              </Text>
            </Flex>
          </Grid>
        </Box>
      </Card>
    </>
  );
};
